import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProjectStatusModel} from './project.status.model';
import {SuppliersService} from '../../../services/suppliers.service';
import {ProleisObject} from "@proleis/proleis-rest-client";
import {BreakpointService} from "@proleis/proleis-web-app";

@Component({
  selector: 'ps-project-status-internal',
  templateUrl: 'project.status.internal.component.html'
})
export class ProjectStatusInternalComponent implements OnInit {

  @Output()
  statusChanged: EventEmitter<ProjectStatusModel> = new EventEmitter<ProjectStatusModel>();
  @Input()
  editable: boolean;

  mobile: boolean;

  _currentStatus: ProjectStatusModel = undefined;
  _previousStatus: ProjectStatusModel = undefined;

  statusObjects: ProleisObject[];
  typeObjects: ProleisObject[];

  constructor(private breakpointService: BreakpointService, private suppliersService: SuppliersService) {

  }


  @Input()
  set currentStatus(status: ProjectStatusModel) {
    this._currentStatus = status;
  }

  get currentStatus() {
    return this._currentStatus;
  }

  @Input()
  set previousStatus(status: ProjectStatusModel) {
    this._previousStatus = status;
  }

  get previousStatus() {
    return this._previousStatus;
  }


  ngOnInit() {
    this.breakpointService.isSmall().subscribe(mobile => {
      this.mobile = mobile;
    });

    this.suppliersService.getTooltypes().subscribe(tooltypes => {
      this.typeObjects = tooltypes;
    });

    this.suppliersService.getConstructionStatus().subscribe(constructionstatus => {
      this.statusObjects = constructionstatus;
    });
  }

  isDifferent(a: any, b: any): boolean {
    return a !== b;
  }

  onChange() {
    this.statusChanged.next(this.currentStatus);
  }

  compareComplexity(o1: any, o2: any) {
    return String(o1) === String(o2);
  }

  compareObjects(o1: ProleisObject, o2: ProleisObject) {
    if (o1.OBJECT_ID === o2.OBJECT_ID) {
      return true;
    } else {
      return false;
    }
  }

}
